import { render, staticRenderFns } from "./popLang.vue?vue&type=template&id=8572191a&scoped=true"
import script from "./popLang.vue?vue&type=script&lang=js"
export * from "./popLang.vue?vue&type=script&lang=js"
import style0 from "./popLang.vue?vue&type=style&index=0&id=8572191a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8572191a",
  null
  
)

export default component.exports